"use strict";

var _interopRequireWildcard = require("@babel/runtime/helpers/interopRequireWildcard");

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.useQueryString = useQueryString;
exports.QueryStringProvider = void 0;

var _slicedToArray2 = _interopRequireDefault(require("@babel/runtime/helpers/slicedToArray"));

var _regenerator = _interopRequireDefault(require("@babel/runtime/regenerator"));

var _typeof2 = _interopRequireDefault(require("@babel/runtime/helpers/typeof"));

var _asyncToGenerator2 = _interopRequireDefault(require("@babel/runtime/helpers/asyncToGenerator"));

var _react = _interopRequireWildcard(require("react"));

var _queryString = require("./query-string");

var _utils = require("./utils");

var defaults = {
  queryString: "",
  parsedQueryString: {
    mc_origen: "",
    utm_medium: ""
  }
};
var QueryStringContext = (0, _react.createContext)(defaults);
var QueryStringContextProvider = QueryStringContext.Provider;

var setupQueryStrings = /*#__PURE__*/function () {
  var _ref = (0, _asyncToGenerator2["default"])( /*#__PURE__*/_regenerator["default"].mark(function _callee() {
    var useCountry,
        country,
        queryString,
        _args = arguments;
    return _regenerator["default"].wrap(function _callee$(_context) {
      while (1) {
        switch (_context.prev = _context.next) {
          case 0:
            useCountry = _args.length > 0 && _args[0] !== undefined ? _args[0] : false;

            if (!((typeof window === "undefined" ? "undefined" : (0, _typeof2["default"])(window)) !== undefined)) {
              _context.next = 13;
              break;
            }

            if (!useCountry) {
              _context.next = 10;
              break;
            }

            if (!location.search.includes("country")) {
              _context.next = 7;
              break;
            }

            country = (0, _utils.getParamFromLocationSearch)("country", location);
            _context.next = 10;
            break;

          case 7:
            _context.next = 9;
            return (0, _queryString.fetchCountry)();

          case 9:
            country = _context.sent;

          case 10:
            queryString = (0, _queryString.getQueryString)(location, document, country);
            window.history.replaceState(null, "", location.pathname + queryString);
            return _context.abrupt("return", queryString);

          case 13:
            return _context.abrupt("return", "");

          case 14:
          case "end":
            return _context.stop();
        }
      }
    }, _callee);
  }));

  return function setupQueryStrings() {
    return _ref.apply(this, arguments);
  };
}();

var QueryStringProvider = function QueryStringProvider(_ref2) {
  var useCountry = _ref2.useCountry,
      children = _ref2.children;

  var _useState = (0, _react.useState)(""),
      _useState2 = (0, _slicedToArray2["default"])(_useState, 2),
      queryString = _useState2[0],
      setQueryString = _useState2[1];

  var _useState3 = (0, _react.useState)({
    mc_origen: "",
    utm_medium: ""
  }),
      _useState4 = (0, _slicedToArray2["default"])(_useState3, 2),
      parsedQueryString = _useState4[0],
      setParsedQueryString = _useState4[1];

  (0, _react.useEffect)(function () {
    var configValue = /*#__PURE__*/function () {
      var _ref3 = (0, _asyncToGenerator2["default"])( /*#__PURE__*/_regenerator["default"].mark(function _callee2() {
        var queryStringFromLocation, paramQueryString;
        return _regenerator["default"].wrap(function _callee2$(_context2) {
          while (1) {
            switch (_context2.prev = _context2.next) {
              case 0:
                _context2.next = 2;
                return setupQueryStrings(useCountry);

              case 2:
                queryStringFromLocation = _context2.sent;
                paramQueryString = (0, _utils.getParamsFromQueryString)(queryStringFromLocation);
                setQueryString(queryStringFromLocation);
                setParsedQueryString(paramQueryString);

              case 6:
              case "end":
                return _context2.stop();
            }
          }
        }, _callee2);
      }));

      return function configValue() {
        return _ref3.apply(this, arguments);
      };
    }();

    configValue();
  }, []);
  return _react["default"].createElement(QueryStringContextProvider, {
    value: {
      queryString: queryString,
      parsedQueryString: parsedQueryString
    }
  }, children);
};

exports.QueryStringProvider = QueryStringProvider;

function useQueryString() {
  var context = _react["default"].useContext(QueryStringContext);

  if (context === undefined) {
    throw new Error("useQueryString must be used within a QueryStringProvider");
  }

  return context;
}